import { rollbar } from 'shared/services/rollbar'
import { StepType } from '../hooks/use-step-router/types'
import { CourseMenuModuleInterface } from '../types/course-menu-interface'
import { CourseStepEnum } from '../types/course-step-type'

export const mapMenuToSteps = (courseMenu: CourseMenuModuleInterface[] | undefined) => {
  if (!courseMenu) return []

  const stepsArray: StepType[] = []

  for (const menuModule of courseMenu) {
    for (const lecture of menuModule.lectures) {
      stepsArray.push({
        module: {
          name: menuModule.name,
          available: menuModule.available,
          salesPage: menuModule.salesPage,
          unavailabilityReason: menuModule.unavailabilityReason,
        },
        type: CourseStepEnum.lecture,
        ...lecture,
      })

      if (lecture.assignment) {
        stepsArray.push({
          module: {
            name: menuModule.name,
            available: menuModule.available,
            salesPage: menuModule.salesPage,
            unavailabilityReason: menuModule.unavailabilityReason,
          },
          type: CourseStepEnum.assignment,
          ...lecture,
        })
      }
    }
    if (menuModule.quiz) {
      stepsArray.push({
        module: {
          name: menuModule.name,
          available: menuModule.available,
          salesPage: menuModule.salesPage,
          unavailabilityReason: menuModule.unavailabilityReason,
        },
        type: CourseStepEnum.quiz,
        ...menuModule.quiz,
      })
    }
  }

  return stepsArray
}

export const findStep = (courseSteps: StepType[]): StepType | undefined => {
  const isTarget = (s: StepType) => {
    if (!s.available) return false

    const isAssignmentUncompleted =
      s.type === CourseStepEnum.assignment && s.assignment?.status == null

    return !s.completed || isAssignmentUncompleted
  }

  return courseSteps.find(isTarget) ?? courseSteps.find(step => step.available) ?? courseSteps[0]
}

export const withModuleAvailability = (modules: CourseMenuModuleInterface[]) => {
  return modules.map(module => {
    const isCompleted =
      module.lectures.every(l => l.completed) && (!module.quiz || module.quiz.completed)
    const shouldShowQuiz = module.lectures.length > 0 && module.available

    if (module.available) {
      return {
        ...module,
        unavailabilityReason: null,
        isCompleted,
        shouldShowQuiz,
      } satisfies CourseMenuModuleInterface
    } else {
      const firstReason = module.lectures[0]?.unavailabilityReason

      if (!firstReason) {
        rollbar.error(
          'Module is not available, but the first lecture has no unavailabilityReason',
          module,
        )
      }
      const unavailabilityReason: Exclude<CourseMenuModuleInterface['unavailabilityReason'], null> =
        firstReason ?? 'not_included_in_partial_access'

      return {
        ...module,
        unavailabilityReason,
        isCompleted,
        shouldShowQuiz,
      } satisfies CourseMenuModuleInterface
    }
  })
}
